import { LinearProgress, Stack, Typography } from "@mui/material";

interface Props {
  completed: number;
  total: number;
  width?: string;
}

const StepsProgress = ({ completed, total, width }: Props) => {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", width: width ?? "100%" }}>
      <LinearProgress
        variant="determinate"
        value={total > 0 ? (completed * 100) / total : 0}
        sx={{ width: "calc(100% - 2rem)", bgcolor: (t) => t.palette.action.selected }}
      />
      <Typography sx={{ whiteSpace: "nowrap" }}>{`${completed.toLocaleString()}/${total.toLocaleString()}`}</Typography>
    </Stack>
  );
};

export default StepsProgress;
